module.exports = __webpack_public_path__ + "img/672-ce8989.png";